import { render, staticRenderFns } from "./GapDetails.vue?vue&type=template&id=26cb1d85"
import script from "./GapDetails.vue?vue&type=script&lang=js"
export * from "./GapDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports